export const formatDateForApi = (date) => {
  if (date == null) return '';

  const day = date.getDate();
  const monthIndex = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${year}-${(`0${monthIndex}`).slice(-2)}-${(`0${day}`).slice(-2)}`;
};

export const formatDateMonthForApi = (date) => {
  if (date == null) return '';

  const monthIndex = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${year}-${(`0${monthIndex}`).slice(-2)}-01`;
};

export const formatTimeForApi = (date) => {
  if (date == null) return '';

  const hour = date.getHours();
  const minute = date.getMinutes();

  return `${(`0${hour}`).slice(-2)}:${(`0${minute}`).slice(-2)}`;
};
